module.exports = __webpack_public_path__ + "images/icons_v2/serial-33cacb03.svg";